export default __webpack_public_path__ + "img/logo-linkedin.98b46637.svg";